import React from 'react';
import styles from './footer.module.scss';
import { Button, Col, ContentContainer, H3, Row } from '@snsw/react-component-library';
import { Accordion, AccordionItem } from '@snsw/react-component-library/build/Components';
import defaultConfig from './defaultConfig';
import { config3ColumnLinks, configFooterLinks } from './serviceNSWLinks';
import AbFlag from './abFlag.svg';
import IlFlag from './ilFlag.svg';
import styled from 'styled-components';

const CustomCol = styled(Col)`
  display: flex;

  & > img {
    margin-right: 18px;
  }
`;

const footerHelp = (config) => {
  return (
    <div className={styles.footeHelp}>
      <ContentContainer>
        <Row className={styles.nonMargin}>
          <Col span={12}>
            <H3 as="span">Do you need help with this form?</H3>
            <p>
              Call us on{' '}
              <Button
                variant="link"
                href={'Tel:' + (config.helpNumber ? config.helpNumber.replace(/\s/g, '') : '137788')}
              >
                {config.helpNumber ? config.helpNumber : '13 77 88'}
              </Button>{' '}
              or{' '}
              <Button href={config.helpForm || '/defaultHelpLink'} variant="link">
                contact us
              </Button>
            </p>
          </Col>
        </Row>
      </ContentContainer>
    </div>
  );
};

const footerAcknowledgementOfCountry = (config) => {
  return (
    <div className={styles.footerAcknowledgementOfCountry}>
      <ContentContainer>
        <Row className={styles.nonMargin}>
          <CustomCol span={12}>
            {!!config.showFlags ? (
              <>
                <img src={AbFlag} alt="Aboriginal flag" />
                <img src={IlFlag} alt="Torres Strait Islander flag" />
              </>
            ) : null}
            <p>
              We pay respect to the Traditional Custodians and First Peoples of NSW, and acknowledge their continued
              connection to their country and culture.
            </p>
          </CustomCol>
        </Row>
      </ContentContainer>
    </div>
  );
};

const mobileThreeColLinks = (config) => {
  return (
    <div
      className={
        styles.threeColLinksFooterMobile + ' ' + (config.threeColLinksTheme == 'dark' ? styles.dark : styles.light)
      }
    >
      <Accordion id="ex3">
        <AccordionItem title={config.threeColLinks.col1Label} expanded>
          {config.threeColLinks.col1Links.map((al) => (
            <p key={al.label} attr-hide-external-svg="true">
              <Button
                href={al.link ? al.link : al.type == 'phone' ? 'Tel:' + al.phone : 'mailto:' + al.email}
                variant="link"
                external={al.external ? true : false}
              >
                {al.label}
              </Button>
            </p>
          ))}
        </AccordionItem>
        <AccordionItem title={config.threeColLinks.col2Label}>
          {config.threeColLinks.col2Links.map((al) => (
            <p key={al.label} attr-hide-external-svg="true">
              <Button
                href={al.link ? al.link : al.type == 'phone' ? 'Tel:' + al.phone : 'mailto:' + al.email}
                variant="link"
                external={al.external ? true : false}
              >
                {al.label}
              </Button>
            </p>
          ))}
        </AccordionItem>
        <AccordionItem title={config.threeColLinks.col3Label}>
          {config.threeColLinks.col3Links.map((al) => (
            <p key={al.label} attr-hide-external-svg="true">
              <Button
                href={al.link ? al.link : al.type == 'phone' ? 'Tel:' + al.phone : 'mailto:' + al.email}
                variant="link"
                external={al.external ? true : false}
              >
                {al.label}
              </Button>
            </p>
          ))}
        </AccordionItem>
      </Accordion>
      {config.threeColLogoUrl ? <img src={config.threeColLogoUrl} alt={'logo'} /> : null}
    </div>
  );
};

const footerThreeColLinks = (config) => {
  return (
    <div
      className={styles.threeColLinksFooter + ' ' + (config.threeColLinksTheme == 'dark' ? styles.dark : styles.light)}
    >
      <ContentContainer>
        <Row className={styles.nonMargin}>
          <Col span={4}>
            <p>{config.threeColLinks.col1Label}</p>
            <ul>
              {config.threeColLinks.col1Links.map((al) => (
                <li key={al.label} attr-hide-external-svg="true">
                  <Button
                    href={al.link ? al.link : al.type == 'phone' ? 'Tel:' + al.phone : 'mailto:' + al.email}
                    variant="link"
                    external={al.external ? true : false}
                  >
                    {al.label}
                  </Button>
                </li>
              ))}
            </ul>
          </Col>
          <Col span={4}>
            <p>{config.threeColLinks.col2Label}</p>
            <ul>
              {config.threeColLinks.col2Links.map((al) => (
                <li key={al.label} attr-hide-external-svg="true">
                  <Button
                    href={al.link ? al.link : al.type == 'phone' ? 'Tel:' + al.phone : 'mailto:' + al.email}
                    variant="link"
                    external={al.external ? true : false}
                  >
                    {al.label}
                  </Button>
                </li>
              ))}
            </ul>
          </Col>
          <Col span={4}>
            <p>{config.threeColLinks.col3Label}</p>
            <ul>
              {config.threeColLinks.col3Links.map((al) => (
                <li key={al.label} attr-hide-external-svg="true">
                  <Button
                    href={al.link ? al.link : al.type == 'phone' ? 'Tel:' + al.phone : 'mailto:' + al.email}
                    variant="link"
                    external={al.external ? true : false}
                  >
                    {al.label}
                  </Button>
                </li>
              ))}
              {config.threeColLogoUrl ? (
                <li key={'logo'}>
                  <img src={config.threeColLogoUrl} alt={'logo'} />
                </li>
              ) : null}
            </ul>
          </Col>
        </Row>
      </ContentContainer>
    </div>
  );
};

const FooterLinks = (config) => {
  return (
    <div className={styles.footerLinks}>
      <ContentContainer>
        <nav>
          <Row className={styles.nonMargin}>
            <Col span={12}>
              <ul>
                {config.footerLinks.map((al) => (
                  <li key={al.label} attr-hide-external-svg={al.showExternalSVG ? 'false' : 'true'}>
                    <Button href={al.link} variant="link" external={al.external ? true : false}>
                      {al.label}
                    </Button>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </nav>
      </ContentContainer>
    </div>
  );
};

const Footer = (props) => {
  let config = props.config
    ? {
        ...defaultConfig,
        ...props.config,
      }
    : defaultConfig;
  if (config.showThreeColLinks === true && config.threeColLinks === undefined) {
    config.threeColLinks = config3ColumnLinks;
  }
  if (config.showFooterLinks === true && config.footerLinks === undefined) {
    config.footerLinks = configFooterLinks;
  }

  return config ? (
    <footer className={styles.globalFooter}>
      {config.showHelpForm !== false && footerHelp(config)}
      {config.showThreeColLinks !== false && config.threeColLinks ? mobileThreeColLinks(config) : null}
      {config.showThreeColLinks !== false && config.threeColLinks ? footerThreeColLinks(config) : null}
      {config.showAcknowledgementOfCountry !== false && footerAcknowledgementOfCountry(config)}
      {config.showFooterLinks !== false && config.footerLinks ? FooterLinks(config) : null}
    </footer>
  ) : null;
};

export default Footer;
